import { RESET, SET_ERROR } from './resetPasswordConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setResetPasswordError = (value) => ({
  type: SET_ERROR,
  payload: value || '',
})
export function reset() {
  return {
    type: RESET,
  }
}
